module.exports = __webpack_public_path__ + "static/media/step-4.1e3abd8e.svg";